//首页
//const HomePage = () => import('@/page/monitoring/home/home.vue')
const HomePage = () => import('@/page/home.vue')

export const home={
    path: '/main/home',
    name: '首页',
    component: HomePage,
    meta: {
        requireAuth: true,
    },
}